module.exports = __webpack_public_path__ + "img/Lubrizol.577913e3.jpg";